import {
  ApiSlugs,
  EmailDto,
  MobileNumberDto,
  TokenExpireTimestampDto,
  UserRegistrationDto,
  UserRegistrationId,
  UserRegistrationIdentityDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';

export class UserRegistrationAuthConnector extends ApiConnector<
  UserRegistrationDto,
  UserRegistrationDto,
  UserRegistrationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.USER_REGISTRATIONS);
  }

  me(): Observable<UserRegistrationDto> {
    return this.apiCaller.getRequest<UserRegistrationDto>(this.apiPrefix, `${this.slug}/me`);
  }

  setMobileNumber(dto: MobileNumberDto): Observable<boolean> {
    return this.apiCaller.postRequest(this.apiPrefix, `${this.slug}/contact/mobile-number`, dto);
  }

  setProfileIdentity(dto: UserRegistrationIdentityDto): Observable<boolean> {
    return this.apiCaller.postRequest(this.apiPrefix, `${this.slug}/identity`, dto);
  }

  convertUserRegistrationToUser(): Observable<EmailDto> {
    return this.apiCaller.postRequest(this.apiPrefix, `${this.slug}/convert-to-user`);
  }

  refreshToken(): Observable<TokenExpireTimestampDto> {
    return this.apiCaller.postRequest<TokenExpireTimestampDto>(
      this.apiPrefix,
      `${this.slug}/refresh-token`,
      null /* {
          withCredentials: true,
        }*/,
    );
  }

  logOut(): Observable<boolean> {
    return this.apiCaller.postRequest<boolean>(this.apiPrefix, `${this.slug}/logout`);
  }
}
